import { render, staticRenderFns } from "./AssetPriceDetails.vue?vue&type=template&id=34caaef1&scoped=true&"
import script from "./AssetPriceDetails.vue?vue&type=script&lang=js&"
export * from "./AssetPriceDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34caaef1",
  null
  
)

export default component.exports